import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios"

type OcrRetryRequestConfig = InternalAxiosRequestConfig & {
    _ocrRetry?: boolean
}

export class OcrApiService {
    private static readonly BASE_URL =
        "https://api-ocr.ubikgs.com/api/v1"

    private static ocrToken: string | null = null
    private static api: AxiosInstance
    private static tokenPromise: Promise<void> | null = null

    private static getApi(): AxiosInstance {
        if (!this.api) {
            this.api = axios.create({
                baseURL: this.BASE_URL
            })

            this.api.interceptors.request.use(async config => {
                if (!this.ocrToken) {
                    await this.getOcrToken()
                }

                config.headers.Authorization = `Bearer ${this.ocrToken}`
                return config
            })

            this.api.interceptors.response.use(
                response => response,
                async error => {
                    const config = error.config as OcrRetryRequestConfig | undefined

                    if (!config || error.response?.status !== 401 || config._ocrRetry) {
                        return Promise.reject(error)
                    }

                    config._ocrRetry = true
                    this.ocrToken = null
                    await this.getOcrToken()

                    config.headers = config.headers ?? {}
                    config.headers.Authorization = `Bearer ${this.ocrToken}`

                    return this.api(config)
                }
            )
        }

        return this.api
    }

    private static async getOcrToken(): Promise<void> {
        if (!this.tokenPromise) {
            this.tokenPromise = axios.post(
                `${this.BASE_URL}/auth/create-token`,
                {
                    "email": "usuario2@gmail.com",
                    "password": "OtraPass123",
                    "timeToken": 3600
                }
            )
                .then(({ data }) => {
                    this.ocrToken = data.token
                })
                .finally(() => {
                    this.tokenPromise = null
                })
        }

        await this.tokenPromise
    }

    public static async getRoadmapMatrix() {
        return this.getApi().get("/matrix/roadmap_matrix", {
            params: { country: "IE" }
        })
    }

    public static async getBuildingPassport() {
        return this.getApi().get("/performance/buildingPassport", {
            params: {
                "latitude": 52.6680,
                "longitude": -8.6305,
                "country": "IE",
                "yearConstruction": 1978,
                "climateZone": "IE",
                "numberDwellings": 1,
                "system": "IE.custom"
            }
        })
    }

    public static async getReport() {
        return this.getApi().post('/config/rpConfig',{
                "latitude": 39.458712,
                "longitude": -0.391257,
                "country": "IT",
                "year": 2025,
                "nUnits": 10,
                "strategy": "IT.custom",
                "objectiveVariable": "GlobalEPNRconsumption",
                "objectiveYear": 2050,
                "stages": 5,
                "durationStage0": 3,
                "durationStage1": 5,
                "durationStage2": 6,
                "durationStage3": 6,
                "durationStage4": 5,

                "globalEPNRconsumptionStage0Resulting": 113.36,
                "letterEPNRconsumptionStage0Resulting": "E",
                "globalDemandStage0Resulting": 68.77,
                "globalCO2emissionsStage0Resulting": 20.74,
                "letterCO2emissionsStage0Resulting": "E",

                "globalEPNRconsumptionStage1Applied": 96.33,
                "letterEPNRconsumptionStage1Applied": "E",
                "globalDemandStage1Applied": 59.68,
                "globalCO2emissionsStage1Applied": 17.86,
                "letterCO2emissionsStage1Applied": "E",

                "globalEPNRconsumptionStage1Resulting": 96.33,
                "letterEPNRconsumptionStage1Resulting": "E",
                "globalDemandStage1Resulting": 59.68,
                "globalCO2emissionsStage1Resulting": 17.86,
                "letterCO2emissionsStage1Resulting": "E",

                "globalEPNRconsumptionStage2Applied": 62.33,
                "letterEPNRconsumptionStage2Applied": "D",
                "globalDemandStage2Applied": 41.09,
                "globalCO2emissionsStage2Applied": 12.1,
                "letterCO2emissionsStage2Applied": "D",

                "globalEPNRconsumptionStage2Resulting": 51.05,
                "letterEPNRconsumptionStage2Resulting": "C",
                "globalDemandStage2Resulting": 35.1,
                "globalCO2emissionsStage2Resulting": 10.74,
                "letterCO2emissionsStage2Resulting": "D",

                "globalEPNRconsumptionStage3Applied": 10.18,
                "letterEPNRconsumptionStage3Applied": "D",
                "globalDemandStage3Applied": 68.77,
                "globalCO2emissionsStage3Applied": 5.83,
                "letterCO2emissionsStage3Applied": "C",

                "globalEPNRconsumptionStage3Resulting": 17.69,
                "letterEPNRconsumptionStage3Resulting": "B",
                "globalDemandStage3Resulting": 35.1,
                "globalCO2emissionsStage3Resulting": 3,
                "letterCO2emissionsStage3Resulting": "B",

                "globalEPNRconsumptionStage4Applied": 82.03,
                "letterEPNRconsumptionStage4Applied": "E",
                "globalDemandStage4Applied": 68.89,
                "globalCO2emissionsStage4Applied": 15.43,
                "letterCO2emissionsStage4Applied": "E",

                "globalEPNRconsumptionStage4Resulting": 0,
                "letterEPNRconsumptionStage4Resulting": "A",
                "globalDemandStage4Resulting": 35.1,
                "globalCO2emissionsStage4Resulting": 0,
                "letterCO2emissionsStage4Resulting": "A",

                "energyBillGlobalStage0Resulting": 4200,
                "energyBillGlobalStage1Applied": 3900,
                "energyBillGlobalStage1Resulting": 3600,
                "energyBillGlobalStage2Applied": 3400,
                "energyBillGlobalStage2Resulting": 3100,
                "energyBillGlobalStage3Applied": 2900,
                "energyBillGlobalStage3Resulting": 2700,
                "energyBillGlobalStage4Applied": 2500,
                "energyBillGlobalStage4Resulting": 2300,

                "maintenaceCostStage0Resulting": 1200,
                "interventionCostStage0Applied": 0,

                "maintenaceCostStage1Resulting": 1500,
                "interventionCostStage1Applied": 5000,

                "maintenaceCostStage2Resulting": 1800,
                "interventionCostStage2Applied": 4500,

                "maintenaceCostStage3Resulting": 2000,
                "interventionCostStage3Applied": 4000,

                "maintenaceCostStage4Resulting": 1700,
                "interventionCostStage4Applied": 3500,

                "measuresStage0Applied": [
                    { "type": "NOT-Mant", "quantity": 0, "cost_unit": 0, "lifespan_years": 2 }
                ],
                "measuresStage0Resulting": [
                    { "type": "Mant", "quantity": 0, "cost_unit": 0, "lifespan_years": 5 }
                ],

                "measuresStage1Applied": [
                    { "type": "NOT-Mant", "quantity": 3, "cost_unit": 150, "lifespan_years": 7 },
                    { "type": "Mant", "quantity": 1, "cost_unit": 40, "lifespan_years": 5 }
                ],
                "measuresStage1Resulting": [
                    { "type": "Mant", "quantity": 2, "cost_unit": 60, "lifespan_years": 8 }
                ],

                "measuresStage2Applied": [
                    { "type": "NOT-Mant", "quantity": 2, "cost_unit": 200, "lifespan_years": 6 },
                    { "type": "Mant", "quantity": 1, "cost_unit": 50, "lifespan_years": 7 }
                ],
                "measuresStage2Resulting": [
                    { "type": "Mant", "quantity": 2, "cost_unit": 80, "lifespan_years": 10 }
                ],

                "measuresStage3Applied": [
                    { "type": "NOT-Mant", "quantity": 4, "cost_unit": 180, "lifespan_years": 4 }
                ],
                "measuresStage3Resulting": [
                    { "type": "Mant", "quantity": 1, "cost_unit": 100, "lifespan_years": 9 }
                ],

                "measuresStage4Applied": [
                    { "type": "NOT-Mant", "quantity": 2, "cost_unit": 250, "lifespan_years": 5 },
                    { "type": "Mant", "quantity": 1, "cost_unit": 60, "lifespan_years": 8 }
                ],
                "measuresStage4Resulting": [
                    { "type": "Mant", "quantity": 2, "cost_unit": 90, "lifespan_years": 10 }
                ]
            }
        )
    }

    public static async getRpConfigGen(payload: Record<string, unknown>) {
        return this.getApi().post("/config/rpConfigGen", payload)
    }
}
